export default "__VITE_PUBLIC_ASSET__45d76fbf__"